import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from '../home/home.component';
import { WildCardGuard } from './wild-card.guard';

const routes: Routes = [
	{
		path: '**',
		component: HomeComponent,
		canActivate: [WildCardGuard]
	}
];

@NgModule({
	declarations: [],
	imports: [CommonModule, RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class WildCardModule {}
